var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.64,
    height: 24.64,
    viewBox: "0 0 24.64 24.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M23.122,13.349l-1.042-1.072a.224.224,0,0,0-.166-.071h0a.215.215,0,0,0-.166.071l-7.226,7.279-2.63-2.63a.229.229,0,0,0-.332,0l-1.054,1.054a.236.236,0,0,0,0,.338l3.317,3.317a1.049,1.049,0,0,0,.693.338,1.1,1.1,0,0,0,.687-.326h.006l7.919-7.961A.253.253,0,0,0,23.122,13.349Z",
    transform: "translate(-1.113 -1.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M15.695,5.033a10.657,10.657,0,1,1-7.54,3.121,10.591,10.591,0,0,1,7.54-3.121m0-1.658a12.32,12.32,0,1,0,12.32,12.32,12.318,12.318,0,0,0-12.32-12.32Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.19e050c3f8ece82d4f0c5424be865115.svg";
export { ForwardRef as ReactComponent };